import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

// GUARDS
import { AuthGuard } from './guards/auth.guard';
import { HomeGuard } from './guards/home.guard';
import { ValidateUserGuard } from './guards/validateuser.guard';

// COMPONENTS
import { RootbarComponent } from './components/rootbar/rootbar.component';
import { FormUploaderComponent } from './components/form-uploader/form-uploader.component';
import { InputTextComponent } from './components/input-text/input-text.component';

// SERVICES
import { CognitoUtil } from './services/cognito.service';
import { Auth } from './services/auth.service';
import { LanguageStoreService } from './services/language-store.service';
import { UserLoginService } from './services/user-login.service';
import { BackendEndpointService } from './services/backend-endpoint.service';
import { BackendWrapperService } from './services/backend-wrapper.service';
import { ShellUpgradeService } from './services/shell-upgrade.service';
import { StyleInjectorService } from './services/style-injector.service';
import { TaxonomyService } from './services/taxonomy-service';
import { TranslationDictionaryService } from './services/translation-dictionary-service';

// SERVICES (REPORTING)
import { StateService } from './services/state.service';
import { CsvExportService } from './services/csv-export.service';
import { SvgExportService } from './services/svg-export.service';
import { PngExportService } from './services/png-export.service';

// NGRX DEPENDECIES
import { EffectsModule } from '@ngrx/effects';
import { effects } from './store/effects';
import { RouterModule } from '@angular/router';
import { BsDropdownModule } from 'ngx-bootstrap';
import { DirectivesModule } from './directives/directives.module';
import { LcpApiService } from './services/lcp-api.service';

@NgModule({
  declarations: [RootbarComponent, InputTextComponent, FormUploaderComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    BsDropdownModule,
    DirectivesModule,

    // NGRX
    EffectsModule.forFeature(effects)
  ],
  exports: [RootbarComponent, InputTextComponent, FormUploaderComponent]
})
export class SharedModule {
  constructor(@Optional() @SkipSelf() parentModule: SharedModule) {
    // if (parentModule) {
    //   throw new Error(
    //     'SharedModule is already loaded. Import it in the AppModule only');
    // }
  }

  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
      providers: [
        AuthGuard,
        HomeGuard,
        ValidateUserGuard,
        CognitoUtil,
        Auth,
        UserLoginService,
        BackendEndpointService,
        BackendWrapperService,
        ShellUpgradeService,
        StyleInjectorService,
        TaxonomyService,
        TranslationDictionaryService,
        LanguageStoreService,
        // used by reporting
        StateService,
        CsvExportService,
        SvgExportService,
        PngExportService,
        // Integrations
        LcpApiService
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts